module.exports = __webpack_public_path__ + "img/bg_poster4.309883b4.png";